<template>
  <app-chip
    class="bg-accent-100 text-accent-950"
    :icon="icon ? icon : undefined"
    :size="size"
  >
    {{ formattedDate }}
    {{ formattedTime ? `⋅ ${formattedTime}` : "" }}
  </app-chip>
</template>

<script lang="ts" setup>
const properties = withDefaults(
  defineProps<{
    session: Pick<
      DatabaseTable<"course_sessions">,
      "start_date" | "end_date" | "timezone"
    >;
    time?: boolean;
    size?: "small";
    icon?: string | false;
  }>(),
  { size: undefined, icon: "ph:calendar-blank" },
);

const formattedDate = useI18nDate(properties.session.start_date ?? "", {
  day: "2-digit",
  month: "short",
  timeZone: properties.session.timezone,
});

const formattedTime = computed(() => {
  if (!properties.time) return;

  return `${
    useI18nDate(properties.session.start_date!, {
      timeStyle: "short",
      timeZone: properties.session.timezone,
    }).value
  } - ${
    useI18nDate(properties.session.end_date!, {
      timeStyle: "short",
      timeZone: properties.session.timezone,
    }).value
  }`;
});
</script>
